// Central asset imports for the Tarana marketing site (ported from the design bundle).
import feed1 from '../assets/site/images/feed-1.png';
import artist1 from '../assets/site/images/artist-1.png';
import artist2 from '../assets/site/images/artist-2.png';
import pumpUp from '../assets/site/images/pump-up.png';
import wordmarkWhite from '../assets/site/logos/tarana-wordmark-white.png';

import backerMib from '../assets/images/backed_by/Ministry_of_Information_and_Broadcasting 1.png';
import backerIict from '../assets/images/backed_by/OIP 3.png';
import backerWavex from '../assets/images/backed_by/wavex.png';
import backerThub from '../assets/images/thub.svg';
import backerDpiit from '../assets/images/dpiit.svg';
import backerMfs from '../assets/images/mfs.svg';

export const IMG = { feed1, artist1, artist2, pumpUp };
export const LOGO = { wordmarkWhite };

export const BACKERS = [
  { name: 'Ministry of Information & Broadcasting', logo: backerMib },
  { name: 'Indian Institute of Creative Technologies', logo: backerIict },
  { name: 'WaveX Accelerator Program', logo: backerWavex },
  { name: 'T-Hub Hyderabad', logo: backerThub },
  { name: 'Startup India · DPIIT Recognised', logo: backerDpiit },
  { name: 'Microsoft for Startups', logo: backerMfs },
] as const;
